import classNames from 'classnames';
import { isProduction } from '@utils';

type Props = {
  isLive: boolean;
  isTop?: boolean;
};

export function PreviewBadge({
  isLive,
  isTop = false
}: Props): JSX.Element | null {
  if (!isProduction && !isLive) {
    return (
      <div
        className={classNames(
          'mx-auto text-lg max-w-prose',
          isTop ? 'mb-14' : 'mt-14'
        )}
      >
        <div className="flex justify-center w-full py-1 font-medium text-white uppercase bg-green-500">
          Preview
        </div>
      </div>
    );
  }

  return null;
}
